import React from 'react';
import {Badge, Card, Checkbox, Col, DatePicker, Form, Input, InputNumber, Row, TimePicker, Typography} from "antd";
import {CodeTreeSelect, CodeTreeSelectFast} from "./CodeTreeSelect";
import {CodeSingleSelect, CodeSingleSelectFast} from "./CodeSingleSelect";
import {CodeMultiSelect, CodeMultiSelectFast} from "./CodeMultiSelect";
import DateTimePicker from "./DateTimePicker";
import {UserSelect} from "./UserSelect";

const { TextArea } = Input;
const { Paragraph } = Typography;

export const DateInput = ({
                     values,
                     errors,
                     handleSubmit,
                     setFieldValue,
                     setFieldTouched,
                     name,
                     placeholder,
                     formItemLayout,
                     label
                   }) => (
  <Form.Item
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <DatePicker
      value={values[name]}
      onChange={event => setFieldValue(name, event)}
      onBlur={() => setFieldTouched(name)}
      format={[
        'MM/DD/YYYY',
        'MM/DD/YY',
        'M/D/YYYY',
        'M/D/YY',
      ]} // requires Ant 3.17
    />
  </Form.Item>
);

export const TimeInput = ({
                            values,
                            errors,
                            handleSubmit,
                            setFieldValue,
                            setFieldTouched,
                            name,
                            placeholder,
                            formItemLayout,
                            label
                          }) => (
  <Form.Item
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <TimePicker
      use12Hours
      onChange={event => setFieldValue(name, event)}
      onBlur={() => setFieldTouched(name)}
      minuteStep={15}
      format={['h:mm A',
        'h:mmA',
        'h A',
        'hA',
      ]} // requires Ant 3.17
    />
  </Form.Item>
);

export const DateTimeInput = ({
                            values,
                            errors,
                            handleSubmit,
                            setFieldValue,
                            setFieldTouched,
                            name,
                            placeholder,
                            formItemLayout,
                            pickerLayout,
                            label
                          }) => (
  <Form.Item
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <DateTimePicker
      value={values[name]}
      onChange={event => setFieldValue(name, event)}
      onBlur={() => setFieldTouched(name)}
      format={[
        'MM/DD/YYYY h:mm A',
        'MM/DD/YYYY h:mmA',
        'MM/DD/YYYY h A',
        'MM/DD/YYYY hA',
        'MM/DD/YY h:mm A',
        'MM/DD/YY h:mmA',
        'MM/DD/YY h A',
        'MM/DD/YY hA',
        'M/D/YYYY h:mm A',
        'M/D/YYYY h:mmA',
        'M/D/YYYY h A',
        'M/D/YYYY hA',
        'M/D/YY h:mm A',
        'M/D/YY h:mmA',
        'M/D/YY h A',
        'M/D/YY hA',
        'MM/DD/YYYY',
        'MM/DD/YY',
        'M/D/YYYY',
        'M/D/YY',
      ]} // requires Ant 3.17
      {...pickerLayout}
    />
  </Form.Item>
);

export const DollarInput = ({
                              values,
                              errors,
                              handleSubmit,
                              setFieldValue,
                              setFieldTouched,
                              name,
                              placeholder,
                              formItemLayout,
                              label
                            }) => (
  <Form.Item
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <InputNumber
      value={values[name]}
      formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
      parser={value => value.replace(/\$\s?|(,*)/g, '')}
      onChange={event => setFieldValue(name, event)}
      onBlur={() => setFieldTouched(name)}
    />
  </Form.Item>
);

export const CheckboxInput = ({
                         values,
                         errors,
                         handleSubmit,
                         setFieldValue,
                         setFieldTouched,
                         name,
                         placeholder,
                         formItemLayout,
                         label,
                         children
                       }) => (
  <Form.Item
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <Checkbox
      checked={values[name]}
      onChange={event => setFieldValue(name, event.target.checked)}
      onBlur={() => setFieldTouched(name)}
    />
    {children}
  </Form.Item>
);

export const CodeTreeInput = ({
                         codes,
                         values,
                         errors,
                         handleSubmit,
                         setFieldValue,
                         setFieldTouched,
                         name,
                         placeholder,
                         formItemLayout,
                         label
                       }) => (
  <Form.Item
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <CodeTreeSelect
      codes={codes}
      value={values[name]}
      onChange={event => {
        setFieldValue(name, event);
      }}
      onBlur={() => setFieldTouched(name)}
    />
  </Form.Item>
);

export const CodeTreeFastInput = ({
                                table,
                                values,
                                errors,
                                handleSubmit,
                                setFieldValue,
                                setFieldTouched,
                                name,
                                placeholder,
                                formItemLayout,
                                label
                              }) => (
  <Form.Item
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <CodeTreeSelectFast
      table={table}
      value={values[name]}
      onChange={event => {
        setFieldValue(name, event);
      }}
      onBlur={() => setFieldTouched(name)}
    />
  </Form.Item>
);


export const CodeSingleInput = ({
                                  codes,
                                  values,
                                  errors,
                                  handleSubmit,
                                  setFieldValue,
                                  setFieldTouched,
                                  name,
                                  placeholder,
                                  defaultValue,
                                  formItemLayout,
                                  label,
                                  ...props
                                }) => (
  <Form.Item
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <CodeSingleSelect
      codes={codes}
      value={values[name]}
      placeholder={placeholder}
      defaultValue={defaultValue}
      onChange={event => setFieldValue(name, event)}
      onBlur={() => setFieldTouched(name)}
      {...props}
    />
  </Form.Item>
);

export const CodeSingleFastInput = ({
                                  table,
                                  values,
                                  errors,
                                  handleSubmit,
                                  setFieldValue,
                                  setFieldTouched,
                                  name,
                                  placeholder,
                                  defaultValue,
                                  formItemLayout,
                                  label,
                                  ...props
                                }) => (
  <Form.Item
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <CodeSingleSelectFast
      table={table}
      value={values[name]}
      placeholder={placeholder}
      defaultValue={defaultValue}
      onChange={event => setFieldValue(name, event)}
      onBlur={() => setFieldTouched(name)}
      {...props}
    />
  </Form.Item>
);


export const CodeMultiInput = ({
                          codes,
                          values,
                          errors,
                          handleSubmit,
                          setFieldValue,
                          setFieldTouched,
                          name,
                          placeholder,
                          formItemLayout,
                          label
                        }) => (
  <Form.Item
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <CodeMultiSelect
      codes={codes}
      value={values[name] || []}
      onChange={event => setFieldValue(name, event)}
      onBlur={() => setFieldTouched(name)}
    />
  </Form.Item>
);

export const CodeMultiFastInput = ({
                                 table,
                                 values,
                                 errors,
                                 handleSubmit,
                                 setFieldValue,
                                 setFieldTouched,
                                 name,
                                 placeholder,
                                 formItemLayout,
                                 label
                               }) => (
  <Form.Item
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <CodeMultiSelectFast
      table={table}
      value={values[name] || []}
      onChange={event => setFieldValue(name, event)}
      onBlur={() => setFieldTouched(name)}
    />
  </Form.Item>
);

export const TemperatureRangeInput = ({
                              values,
                              errors,
                              handleSubmit,
                              setFieldValue,
                              setFieldTouched,
                              name,
                              placeholder,
                              formItemLayout,
                              label
                            }) => (
  <Form.Item
    className='temperature-input-wrapper'
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    Lo{' '}
    <InputNumber
      className='temperature-input'
      min={-50}
      max={200}
      placeholder='deg'
      value={values[name+'lo']}
      formatter={value => `${value}°F`}
      parser={value => value.replace(/°F/, '')}
      onChange={event => setFieldValue(name+'lo', event)}
      onBlur={() => setFieldTouched(name+'lo')}
    />
    {' '}- Hi{' '}
    <InputNumber
      className='temperature-input'
      min={-50}
      max={200}
      placeholder='deg'
      value={values[name+'hi']}
      formatter={value => `${value}°F`}
      parser={value => value.replace(/°F/, '')}
      onChange={event => setFieldValue(name+'hi', event)}
      onBlur={() => setFieldTouched(name+'hi')}
    />
  </Form.Item>
);

export const NumberInput = ({
                              values,
                              errors,
                              handleSubmit,
                              setFieldValue,
                              setFieldTouched,
                              name,
                              placeholder,
                              formItemLayout,
                              label
                            }) => (
  <Form.Item
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <InputNumber
      value={values[name]}
      onChange={event => setFieldValue(name, event)}
      onBlur={() => setFieldTouched(name)}
    />
  </Form.Item>
);

export const TextInputDisabled = ({
                            values,
                            errors,
                            handleSubmit,
                            setFieldValue,
                            setFieldTouched,
                            name,
                            placeholder,
                            formItemLayout,
                            label,
                            inputProps,
                          }) => (
  <Form.Item
    // prefixCls={} label={} labelCol={}  wrapperCol={} className={} id={} colon={}
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <Input
      placeholder={placeholder || 'input...'}
      value={values[name]}
      onChange={event => setFieldValue(name, event.target.value)}
      onBlur={() => setFieldTouched(name)}
      disabled
      {...inputProps}
      style={{
        backgroundColor: 'white',
        color: 'rgba(0, 0, 0, 0.65)',
        ...(inputProps||{}).style
      }}
    />
  </Form.Item>
);

export const TextInput = ({
                            values,
                            errors,
                            handleSubmit,
                            setFieldValue,
                            setFieldTouched,
                            name,
                            placeholder,
                            formItemLayout,
                            label,
                            inputProps,
                          }) => (
  <Form.Item
    // prefixCls={} label={} labelCol={}  wrapperCol={} className={} id={} colon={}
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <Input
      placeholder={placeholder || 'input...'}
      value={values[name]}
      onChange={event => setFieldValue(name, event.target.value)}
      onBlur={() => setFieldTouched(name)}
      {...inputProps}
    />
  </Form.Item>
);

export const PasswordValidationElement = ({type, value}) => {
  const validator = {
    length: {
      logic: value.length >= 8,
      description: 'Your password must be at least 8 characters.',
    },
    lower: {
      logic: /[a-z]/.test(value),
      description: 'Your password must have a lower-case letter in it.',
    },
    upper: {
      logic: /[A-Z]/.test(value),
      description: 'Your password must have an upper-case letter in it.',
    },
    digit: {
      logic: /[0-9]/.test(value),
      description: 'Your password must have a number in it.',
    },
    special: {
      logic: /[^a-zA-Z0-9]/.test(value),
      description: 'Your password must have a special character in it.',
    },
  }
  const validation = {
    success: {
      class: 'color-grayscale-4',
      status: 'success',
      text: validator[type].description,
    },
    error: {
      class: 'color-grayscale-0',
      status: 'default',
      text: validator[type].description,
    },
  }
  const isSuccess = validator[type].logic;
  const match = isSuccess ? validation.success : validation.error;
  return <Col xs={24} md={12}><Badge status={match.status} className={match.class} text={match.text}/></Col>;
};

export const PasswordInput = ({
                     values,
                     errors,
                     handleSubmit,
                     setFieldValue,
                     setFieldTouched,
                     name,
                     placeholder,
                     formItemLayout,
                     label,
                     inputProps,
                   }) => {
  const value = values[name] || '';
  const requirements = ['length', 'digit', 'lower', 'upper', 'special'];
  return <React.Fragment>
    <Col xs={0} xl={0}>
      <div style={{ position: 'relative', height: 0 }}>
        <div style={{ position: 'absolute', top: -124, left: 377, width: 300 }}>
          <Card style={{ textAlign: 'left' }}>
            {requirements.map(type => PasswordValidationElement({ type, value }))}
          </Card>
        </div>
      </div>
    </Col>
    <Form.Item
      // prefixCls={} label={} labelCol={}  wrapperCol={} className={} id={} colon={}
      validateStatus={errors[name] && 'error'}
      hasFeedback={!!errors[name]}
      help={errors[name]}
      label={label}
      style={{ marginBottom: 2 }}
      {...formItemLayout}
    >
      <Input
        placeholder={placeholder || 'input...'}
        value={values[name]}
        onChange={event => setFieldValue(name, event.target.value)}
        onBlur={() => setFieldTouched(name)}
        type={'password'}
        validate={value => {
          let error;
          if (!value) error = 'Required';
          else if (!/[a-z]/.test(value)) error = 'Lowercase';
          else if (!/[A-Z]/.test(value)) error = 'Uppercase';
          else if (!/[0-9]/.test(value)) error = 'Number';
          else if (!/[^a-zA-Z0-9]/.test(value)) error = 'Special';
          return error;
        }}
        {...inputProps}
      />
    </Form.Item>
    <Col>
      <div className='validation-requirements' style={{ marginBottom: 24, textAlign: 'left' }}>
        <Row type='flex' style={{ alignItems: 'center' }} gutter={8}>
          {requirements.map(type => PasswordValidationElement({ type, value }))}
        </Row>
      </div>
    </Col>
  </React.Fragment>;
};

export const TextAreaInput = ({
  values,
  errors,
  handleSubmit,
  setFieldValue,
  setFieldTouched,
  name,
  placeholder,
  formItemLayout,
  label,
  rows,
  autosize
}) => (
  <Form.Item
    // prefixCls={} label={} labelCol={}  wrapperCol={} className={} id={} colon={}
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <TextArea
      placeholder={placeholder || 'input...'}
      value={values[name]}
      onChange={event => setFieldValue(name, event.target.value)}
      onBlur={() => setFieldTouched(name)}
      rows={rows}
      autosize={autosize}
    />
  </Form.Item>
);

export const UserSelectInput = ({
  values,
  errors,
  handleSubmit,
  setFieldValue,
  setFieldTouched,
  name,
  placeholder,
  formItemLayout,
  label,
  rows,
  autosize,
  onSearch,
  disabled
}) => (
  <Form.Item
    validateStatus={errors[name] && 'error'}
    hasFeedback={!!errors[name]}
    help={errors[name]}
    label={label}
    {...formItemLayout}
  >
    <UserSelect
      placeholder={placeholder || 'input...'}
      value={values[name]}
      onChange={value => setFieldValue(name, value)}
      onBlur={() => setFieldTouched(name)}
      autosize={autosize}
      onSearch={onSearch}
      disabled={disabled}
    />
  </Form.Item>
);


// WEBPACK FOOTER //
// ./src/components/Boilerplate/formikComponents.js